import { iconStyle } from "./styles";

export const BLUE_LINE_TEST_ID = "blue-dot-icon";

export default function BlueDotIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={iconStyle}
      data-testid={BLUE_LINE_TEST_ID}
    >
      <g
        style={{
          mixBlendMode: "multiply",
        }}
      >
        <rect x="2.5" y="8.75" width="15" height="2.5" fill="#547DEB" />
      </g>
    </svg>
  );
}
